// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"CreativePopupTabs-primaryButton-1z-gNw","container":"CreativePopupTabs-container-Rl4x2-","tabsContainer":"CreativePopupTabs-tabsContainer-88-XbH"};